import React, { useState } from 'react';
import type { FAQItem as FAQItemType } from './support.data';
import FAQItem from './FAQItem';

interface FAQSectionProps {
  items: FAQItemType[];
  title?: string;
  description?: string;
}

const FAQSection: React.FC<FAQSectionProps> = ({
  items,
  title = 'Frequently Asked Questions',
  description = 'Quick answers to common questions about Pixle.',
}) => {
  const [openId, setOpenId] = useState<string | null>(null);

  if (items.length === 0) return null;

  const handleToggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="support-block" aria-labelledby="support-faq-heading">
      <h2 id="support-faq-heading" className="support-block-title">
        {title}
      </h2>
      <p className="support-block-subtitle">{description}</p>
      <div className="support-faq-list">
        {items.map((item) => (
          <FAQItem key={item.id} item={item} isOpen={openId === item.id} onToggle={handleToggle} />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
